<app-header *ngIf="skin.whiteLabel !== 'TRACKI'"></app-header>

<div class="auth-container" [ngClass]="skin.whiteLabel">
    <div class="wrapper" *ngIf="skin.whiteLabel !== 'TRACKI'">
        <div class="auth-container-form" rtl>
            <div class="container">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>

    <ng-container *ngIf="skin.whiteLabel === 'TRACKI'">
        <div class="side-bar">
            <router-outlet></router-outlet>
        </div>

        <div class="main"></div>
    </ng-container>
</div>

<app-footer *ngIf="skin.whiteLabel !== 'TRACKI'"></app-footer>